$(document).ready(function() {
  function setActiveTab(activeClass, inactiveClass) {
    $(activeClass).addClass('active-tab');
    $(inactiveClass).removeClass('active-tab');
  }

  function smoothScrollTo(targetId) {
    $('html, body').animate({
      scrollTop: $(targetId).offset().top
    }, 1000); // Adjust the duration (600ms) as needed
  }

  // Set the initial active tab
  setActiveTab('.product-tab-section', '.package-tab-section');
  
  $('.product-tab-section').click(function() {
    $('#switch-smooth-package').hide();
    $('#switch-smooth-product').show();
    setActiveTab('.product-tab-section', '.package-tab-section');
    smoothScrollTo('#switch-smooth-product');
  });

  $('.package-tab-section').click(function() {
    $('#switch-smooth-product').hide();
    $('#switch-smooth-package').show();
    setActiveTab('.package-tab-section', '.product-tab-section');
    smoothScrollTo('#switch-smooth-package');
  });
});
